import { Avatar, Box, Dialog, Grid, IconButton } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { IStructuredError } from "store/types";

interface IProps {
  open: boolean;
  onClose: () => any;
  errors: IStructuredError[];
}

const style = {
  height: "150px",
  width: "530px",
  bgcolor: "#FFFFFF",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
  p: 4,
};

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
`;

const Error = styled.p`
  font-family: "Roboto";
  font-style: "normal";
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin: 0px;
`;

export const RuleErrorsDialog = ({ open, onClose, errors }: IProps) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog">
      <Box sx={style}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={1}>
            {
              <Avatar sx={{ backgroundColor: "#FEF1F2" }}>
                <ErrorOutlineIcon sx={{ color: "#881113" }} />
              </Avatar>
            }
          </Grid>
          <Grid item xs={10}>
            <PageTitle>Failed to save new version</PageTitle>
          </Grid>
          <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: "#414141",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <p>Review the following and try again:</p>
        {errors.map((e, i) => (
          <Error key={i}>
            {e.line !== -1 ? `${e.line}: ` : ""}
            {e.error}
          </Error>
        ))}
      </Box>
    </Dialog>
  );
};
